import React, { FC, useEffect } from "react";

import { Box } from "@mui/material";

import { KVideoWidget as KVideoWidgetModel } from "../../../models/configuration/components/kVideoWidget";
import { WidgetUIState } from "../atoms";
import { useWidgetState } from "../hooks";
import { KWidgetProps } from "../models";

export type KVideoWidgetProps = {
  widgetId: KVideoWidgetModel["id"];
} & Omit<KVideoWidgetModel, "id"> &
  KWidgetProps;

const KVideoWidget: FC<React.PropsWithChildren<KVideoWidgetProps>> = function ({
  autoPlay,
  controls,
  loop,
  position,
  poster,
  posterResource,
  src,
  resource,
  width,
  widgetId,
  type,
}) {
  const videoUrl = resource?.url || src;
  const posterUrl = posterResource?.url || poster;

  const { setWidgetState, widgetState } = useWidgetState({
    id: widgetId,
    type,
  });

  useEffect(() => {
    // Do not render if we do not have at least:
    if (!!!videoUrl) {
      setWidgetState({ state: WidgetUIState.NULL });
    } else {
      setWidgetState({ state: WidgetUIState.RENDERED });
    }
  }, [videoUrl, setWidgetState]);

  if (widgetState.state === WidgetUIState.RENDERED) {
    return (
      <Box
        sx={{
          display: "flex",
          flex: 1,
        }}
        style={{
          justifyContent: position?.horizontal ?? "center",
          alignItems: position?.vertical ?? "center",
        }}
        className="KVideoWidget"
        data-testid="KVideoWidget"
      >
        <video
          // Need a key here to reload video component on video url change (can happen during a change from the frontedit)
          key={`${videoUrl}-${posterUrl}-${controls}-${loop}-${autoPlay}`}
          autoPlay={autoPlay}
          controls={controls}
          loop={loop}
          poster={posterUrl}
          muted
          width={width}
        >
          <source src={videoUrl} />
        </video>
      </Box>
    );
  }
  return null;
};

export default KVideoWidget;
